import {EventsInteractor} from './EventsInteractor';
import {CalendarEvent, RsvpResponse} from '../Models/CalendarEvent';
import {NetworkResult} from '../Network/NetworkResult';
import {map, Observable, scan, shareReplay} from 'rxjs';
import {lazy} from '../Support/lazy';

export interface Rsvp {
    scheduledEventId: number;
    userId: number;
    startsAt: Date;
    rsvpResponse: RsvpResponse;
}

export class RsvpInteractor {
    @lazy()
    public get rsvps(): Observable<Rsvp[]> {
        return this.eventsInteractor.calendarEvents.pipe(
            map((events) => {
                return events.reduce<Rsvp[]>((rsvps, event: CalendarEvent) => {
                    return [
                        ...rsvps,
                        ...event.rsvpStatuses.map((rsvpStatus) => {
                            return {
                                scheduledEventId: event.scheduledEventId,
                                userId: rsvpStatus.userId,
                                startsAt: event.startAt,
                                rsvpResponse: rsvpStatus.response,
                            };
                        }),
                    ];
                }, []);
            }),
            scan((acc: Rsvp[], rsvps) => {
                //We can simply accumulate them since RSVPs can't be deleted
                return [
                    ...acc.filter((rsvp) => {
                        return !rsvps.some((rsvp2) => {
                            return (
                                rsvp.scheduledEventId === rsvp2.scheduledEventId &&
                                rsvp.userId === rsvp2.userId &&
                                rsvp.startsAt.getTime() === rsvp2.startsAt.getTime()
                            );
                        });
                    }),
                    ...rsvps,
                ];
            }, []),
            shareReplay(1),
        );
    }

    public forScheduledEventOnDate(scheduledEventId: number, date: Date) {
        return this.rsvps.pipe(
            map((rsvps) => {
                return rsvps.filter((rsvp) => {
                    return rsvp.scheduledEventId === scheduledEventId && rsvp.startsAt.getTime() === date.getTime();
                });
            }),
        );
    }

    constructor(private eventsInteractor: EventsInteractor) {}

    public async reply(
        scheduledEventId: number,
        userId: number,
        startsAt: Date,
        rsvpResponse: RsvpResponse,
    ): Promise<NetworkResult<any>> {
        return await this.eventsInteractor.rsvp(scheduledEventId, userId, startsAt, rsvpResponse);
    }
}
